import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { ObjectStatus } from 'src/app/shared/model/object';
import { utils, write, WorkBook } from 'xlsx';
import * as XLSX from 'xlsx';
import {saveAs } from 'file-saver'
import { GeneralFunctionsService } from 'src/app/shared/general-functions.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-status-list',
  templateUrl: './status-list.component.html',
  styleUrls: ['./status-list.component.less']
})
export class StatusListComponent implements OnInit {

  @Input() objectid : number;
  statuslist : Array<ObjectStatus> = null;




  constructor(  private objectenService: ObjectenService,
                private functions: GeneralFunctionsService,
                private router: Router

  ) { }

  ngOnInit() {

    // this.objectenService.getObjectStatusList(this.objectid).subscribe(data => {
    //     this.statuslist = data;
    // })

    this.objectenService.getStatusList();

  }

  /* objectid changes */
  ngOnChanges(changes: SimpleChanges) {
    this.objectenService.getObjectStatusList(this.objectid).subscribe(data => {
      this.statuslist = data as Array<ObjectStatus>;
    })
  }

  addNew() {
    var status = new ObjectStatus();
    status.ID = null;
    status.ObjectID = this.objectid;
    this.statuslist.push(status);
  }

  deleted(id: any) {
    this.statuslist.forEach( (item, index) => {
      if(item.ID === id) {
        this.statuslist.splice(index,1);
      }
  });
  }

  rapport() {
    this.router.navigateByUrl("/objecten/statusrapport/" + this.objectid)
  }

  private numToAlpha(num) {

  var alpha = '';

  for (; num >= 0; num = parseInt("" + (num / 26), 10) - 1) {
    alpha = String.fromCharCode(num % 26 + 0x41) + alpha;
  }

  return alpha;
}

  excel() {
      this.objectenService.getObjectStatusExportList(this.objectid).subscribe( result=> {
        try {
          const ws_name = 'factuur';
          const wb: WorkBook = { SheetNames: [], Sheets: {} };
          const ws: any = utils.json_to_sheet(result);
          wb.SheetNames.push(ws_name);
          wb.Sheets[ws_name] = ws;
          //const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type:'binary' });
          //saveAs(new Blob([this.functions.s2ab(wbout)],{type:"application/octet-stream"}), 'factuur.xlsx');

        let totaal = result.reduce( (a,v) => (isNaN(a) ? 0 :a) + v["KostenEuro"] * 1)
        let row = result.length+2;
        ws["!ref"] = "A1:G" + row;
        ws["A" + row] = {"t":"s","v": "Totaal",s: {font: {sz: 14, bold: true }}};
        ws["G" + row] = {"t":"n","v": totaal};
        ws["!merges"] = [
				  {s:{r:row-1,c:0},e:{r:row-1,c:5}}
			  ]// row commences at 0
        let i; 
        for (i = 2; i < row; i++) {
          ws["E" + i].t = "d"
          ws["F" + i].t = "d"
          ws["E" + i].v = Date.parse(ws["E" + i].v)
        }
        console.log(ws)
        const wob = XLSX.writeFile({
          SheetNames:["Sheet1"],
          Sheets:{"Sheet1": ws}
        }, 'test.xlsx');
        console.log(wob)
        } catch (E) {
          console.log(E);
        }
      })
  }


}
